export function isObject(x: any): x is Object {
  return x != null && typeof x === 'object';
}



// WEBPACK FOOTER //
// ./node_modules/rxjs/src/util/isObject.ts